<template>

  <section>

    <div class="modal-card">

      <header class=" modal-card-head ">
        <p class="modal-card-title ">Add Documents</p>
      </header>

      <section class="modal-card-body">

        <b-field>
          <b-upload
            v-model="dropFiles"
            multiple
            drag-drop
          >
            <section class="section">
              <div class="content has-text-centered">
                <p>
                  <b-icon
                    icon="upload"
                    size="is-large"
                  >
                  </b-icon>
                </p>
                <p>Drop your files here or click to select</p>
              </div>
            </section>
          </b-upload>
        </b-field>

        <progress
          v-if="$store.state.uploadPercentage > 0"
          class="progress is-success"
          max="100"
          :value.prop="$store.state.uploadPercentage"
        ></progress>

        <div class="tags">
          <span
            v-for="(file, index) in dropFiles"
            :key="index"
            class="tag is-primary"
          >
            {{file.name}}
            <button
              class="delete is-small"
              type="button"
              @click="deleteDropFile(index)"
            >
            </button>
          </span>
        </div>

      </section>

      <footer class="modal-card-foot">
        <button
          class="button"
          v-bind:disabled="$store.state.isUploading"
          type="button"
          @click="$store.state.isAddDocumentsActive = false"
        >Cancel</button>
        <button
          class="button is-primary"
          v-bind:disabled="$store.state.isUploading"
          @click="upload()"
        >Upload</button>
      </footer>
    </div>
  </section>
</template>

<script>
import LiberatorService from "@/services/LiberatorService.js";
var axios = require("axios");

export default {
  components: {
    LiberatorService
  },

  data() {
    return {
      files: new FormData(),
      dropFiles: []
    };
  },

  methods: {
    deleteDropFile(index) {
      this.dropFiles.splice(index, 1);
    },

    async upload() {
      this.$store.commit("SET_UPLOAD_STATUS", true);

      var i = 0;
      var totalSize = 0;
      for (i = 0; i < this.dropFiles.length; i++) {
        totalSize += this.dropFiles[i].size;
      }
      console.log("Total upload size=", totalSize);

      var baseLoaded = 0;
      for (i = 0; i < this.dropFiles.length; i++) {
        var file = this.dropFiles[i];
        console.log("file", file);

        var result = await LiberatorService.getPresignedUrlForDocuments(
          this.$store.state.property.id,
          file.name,
          file.type
        );
        var presignedUrl = result.data.url;
        var s3Key = result.data.s3Key;

        console.log("result", result.data);

        var totalUploaded = 0;

        if (presignedUrl.length > 0) {
          var options = {
            onUploadProgress: progressEvent => {
              totalUploaded = progressEvent.loaded + baseLoaded;
              this.$store.state.uploadPercentage = parseInt(
                Math.round((totalUploaded / totalSize) * 100)
              );
              console.log("loaded, total", totalUploaded, totalSize);
            },
            headers: {
              "Content-Type": file.type
            }
          };
          console.log("options", options);
          await axios
            .put(presignedUrl, file, options)
            .then(response => {
              console.log("response", response);
            })
            .catch(error => {
              console.log("error", error);
            });
        } else
          console.log(
            "presignedUrl.length less than zero",
            presignedUrl.length
          );

        baseLoaded += file.size;

        var propertyId = this.$store.state.property.id;
        var name = file.name;
        var type = file.type;
        var size = file.size;
        await this.$store.dispatch("addDocument", {
          propertyId,
          name,
          type,
          s3Key,
          size
        });
      }

      this.$store.state.isAddDocumentsActive = false;

      this.$store.commit("SET_UPLOAD_STATUS", false);
    }
  }
};
</script>

<style>
</style>
